let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ibIy0")).then(() => parcelRequire('bJwMY'));